import type { TemplateSlot } from "../utils/derive-template";
import { SchedulePeriodicSection } from "./SchedulePeriodicSection";

interface ScheduleMonthlySectionProps {
  readonly slots: readonly TemplateSlot[];
  readonly onEditSlot: (slot: TemplateSlot) => void;
  readonly onAddSlot?: () => void;
  readonly onContextMenu?: (slot: TemplateSlot, anchorRect: DOMRect) => void;
}

export function ScheduleMonthlySection(props: ScheduleMonthlySectionProps) {
  return <SchedulePeriodicSection title="Mensuel" {...props} />;
}
